import "@/assets/css/custom-new-datepicker.css";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "@fullcalendar/timeline/main.css";
import "@fullcalendar/list/main.css";
import "@fullcalendar/resource-timeline/main.css";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/vi";
import "element-ui/lib/theme-chalk/display.css";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/common.css";
import "@/assets/css/new-style.css";
import "@/assets/css/custom-element.css";
import "@/assets/css/custom-multiple-select.css";
import "@/assets/css/custome-new-calendar.css";
import "@/assets/css/responsive.css";
import '@/assets/js/vgcaplugin.js';

import Vue from "vue";
import InfiniteLoading from "vue-infinite-loading";
import Multiselect from "vue-multiselect";
import AppMain from "./App_main";
import * as mixins from "./mixins/mixin";
import router from "./router";
import store from "./store";
import handleRequestErrorMixin from "./views/handleRequestErrorMixin";
import VueProgressBar from "vue-progressbar";
import "@/configProgressbar.js";
import openInNewTabDirectives from "./directives/openInNewTabDirectives";
import VueKonva from 'vue-konva'
import { syncServerTime } from "./dateUtils";

Vue.use(VueKonva);

Vue.use(VueProgressBar, {
  color: "#F0C330",
  failedColor: "yellow",
  thickness: "2px"
});

Vue.use(InfiniteLoading);

Vue.component("multiselect", Multiselect);
Vue.use(ElementUI, {
  locale
});

Object.keys(mixins).forEach(key => {
  Vue.mixin(mixins[key]);
});

Vue.mixin(handleRequestErrorMixin);

Vue.mixin({
  data() {
    return {
      perfectScrollbarSetting: {
        maxScrollbarLength: 550
      }
    };
  }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */

Vue.directive("focus", {
  bind: function(el, binding, vnode) {
    el.children[0].focus();
  },
  inserted: function(el, binding, vnode) {
    el.children[0].focus();
  }
});

Vue.directive("openInNewTab", openInNewTabDirectives);

void syncServerTime();

export default new Vue({
  el: "#app",
  router,
  store,
  components: {
    AppMain
  },
  template: "<AppMain/>"
});



// WEBPACK FOOTER //
// ./src/main.js